export const SET_WORKSPACE = 'SET_WORKSPACE';
export const SET_USER = 'SET_USER';
export const SET_TPUSER = 'SET_TPUSER';
export const SET_USERS = 'SET_USERS';
//SET CURRENT VIEW OF THE MAIN APPBAR
export const SET_APPBAR_VIEW = 'SET_APPBAR_VIEW';
export const SET_USER_WORKSPACE = 'SET_USER_WORKSPACE';

export const SET_TEAM = 'SET_TEAM';
export const UPDATE_ASSISTANT_NAME = 'UPDATE_ASSISTANT_NAME';

export const USER_WORKSPACE_MEMBERSHIP = 'USER_WORKSPACE_MEMBERSHIP';
export const SHOW_APP_HOME_IN_FULL_VIEW = 'SHOW_APP_HOME_IN_FULL_VIEW';
